import { useLazyQuery } from '@apollo/client';
import { apolloClient } from '../utils/apollo';
import { WatchQueryFetchPolicy } from '@apollo/client/core/watchQueryOptions';
import { GetContractsWithoutDiagnosesAndClientConsentsAndClientOverviewDocument } from '@upheal/graphql/definitions/contracts/GetContractsWithoutDiagnosesAndClientConsentsAndClientOverview.generated';
import { GetContractWithoutDiagnosesAndClientConsentsAndClientOverviewDocument } from '@upheal/graphql/definitions/contracts/GetContractWithoutDiagnosesAndClientConsentsAndClientOverview.generated';

type Props = {
    fetchPolicy?: WatchQueryFetchPolicy;
};

export const useContractsListLazy = ({
    fetchPolicy = 'cache-first',
}: Props = {}) => {
    const [fetchContracts, { loading: loadingContracts }] = useLazyQuery(
        GetContractsWithoutDiagnosesAndClientConsentsAndClientOverviewDocument,
        {
            fetchPolicy,
            client: apolloClient,
            onCompleted: (data) => {
                data.contracts.forEach((contract) => {
                    apolloClient.cache.writeQuery({
                        query: GetContractWithoutDiagnosesAndClientConsentsAndClientOverviewDocument,
                        data: { contract },
                        variables: {
                            contractId: contract.id,
                        },
                    });
                });
            },
        },
    );

    return {
        fetchContracts,
        loadingContracts,
    };
};
